export default __webpack_public_path__ + "2adae6b4aa330e7e05a3fe8927cec126.png";